export const CommonUtil = {
    getOrDefault : (obj, keyName, defaultValue, allowNulls) => {
        if (allowNulls === undefined) {
            allowNulls = false;
        }

        if (obj !== undefined && obj !== null && typeof obj === 'object') {
            if (obj.hasOwnProperty(keyName)) {
                if ((!allowNulls && obj[keyName] != null) || allowNulls) {
                    return obj[keyName];
                }
            }
        }
        return defaultValue;
    },
    cloneObject : (object) => {
        return Object.assign({}, object)
    },
    mergeObjects : (o1, o2) => {
        let newFormData = CommonUtil.cloneObject(o1);

        Object.keys(o2).forEach((key) => {
            if (key !== "step") {
                newFormData[key] = o2[key];
            }
        });

        return newFormData;
    },
    getGoogleMapsLink : (addressParts) => {
        let searchQuery = "";
        if (Array.isArray(addressParts)) {
            addressParts.forEach((part) => {
                if (part !== undefined) {
                    if (searchQuery !== "") {
                        searchQuery += "+";
                    }
                    searchQuery += encodeURIComponent(part.toLowerCase().replaceAll(" ", "+"));
                }
            });
        } else {
            searchQuery = encodeURIComponent(addressParts.replaceAll(" ", "+"));
        }

        return "https://www.google.com/maps/search/" + searchQuery + "/";
    },
    implode : (data, delimiter) => {
        if (delimiter === undefined) {
            delimiter = ", ";
        }

        let out = "";

        for (let i = 0; i < data.length; i++) {
            if (data[i] !== null && data[i] !== "") {
                if (out !== "") {
                    out += delimiter;
                }
                out += data[i];
            }
        }

        return out;
    },
    isObject : (input) => {
        return (
            input !== null
            &&typeof input === 'object'
            && !Array.isArray(input)
        );
    }
}